import React from 'react'

const CellRadio = ({ text, value, checked, onCheck }) => (
  <div className={checked ? 'cell-input active' : 'cell-input'}>
    <label htmlFor={`amountMonthly${value}`}>{text}</label>
    <div className="radio" id={`uniform-amountMonthly${value}`}>
      <span className={checked ? 'checked' : ''}>
        <input
          type="radio"
          id={`amountMonthly${value}`}
          name="amountMonthly"
          value={value}
          onChange={onCheck}
          checked={checked}
        />
      </span>
    </div>
  </div>
)

class Footer extends React.PureComponent {
  constructor() {
    super()
    this.state = { checked: 500 }
    this.onCheck = this.onCheck.bind(this)
  }
  onCheck(evt) {
    this.setState({ checked: Number.parseInt(evt.target.value, 10) })
  }

  render() {
    return (
      <div style={{ minWidth: 512 }}>
        <div className="block alt-2">
          <div className="anchor-100" id="zapojte-se" />
          <div
            className="row"
            style={{ maxWidth: '100%', textAlign: 'center' }}
          >
            <div className="grid_24" style={{ maxWidth: '100%', margin: 0 }}>
              <header className="section-head">
                <h2>Pomozte prosadit zákony Rekonstrukce státu</h2>
              </header>
            </div>

            <div
              className="grid_10 suffix_2 omega"
              style={{ display: 'inline-block', textAlign: 'left' }}
            >
              <h3>
                <b>Chci přispět</b> na monitoring slibů
              </h3>
              <form
                role="form"
                className="std form-donate"
                id="donateminform"
                method="get"
                encType="application/x-www-form-urlencoded"
                action="/cs/zapoj-se#donate"
                noValidate
                data-error-element="label"
                data-error-class="error"
              >
                {' '}
                <div className="amount-radio-set">
                  <div className="cell-set ib hl">
                    <CellRadio
                      checked={this.state.checked === 300}
                      onCheck={this.onCheck}
                      text="300 Kč"
                      value={300}
                    />
                    <CellRadio
                      checked={this.state.checked === 500}
                      onCheck={this.onCheck}
                      text="500 Kč"
                      value={500}
                    />
                    <CellRadio
                      checked={this.state.checked === 1000}
                      onCheck={this.onCheck}
                      text="1000 Kč"
                      value={1000}
                    />
                    <CellRadio
                      checked={this.state.checked === 0}
                      onCheck={this.onCheck}
                      text="jiná"
                      value={0}
                    />
                  </div>
                  <div
                    className="custom-amount"
                    style={{
                      display: this.state.checked === 0 ? 'block' : 'none',
                    }}
                  >
                    <div className="cell-set last">
                      <div className="cell ib">
                        <div className="input-1">
                          <div className="input">
                            <input
                              type="text"
                              name="otherAmountMonthly"
                              id="otherAmountMonthly"
                              className="text"
                              placeholder="Jiná částka"
                            />
                          </div>
                        </div>{' '}
                        <div className="input-2">Kč</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="more-divider">
                  <div className="btn-wrapper">
                    <button
                      type="submit"
                      id="send"
                      name="send"
                      className="btn"
                      value="send"
                    >
                      Darovat
                    </button>
                  </div>{' '}
                </div>
              </form>{' '}
            </div>

            <div
              className="grid_12 alpha"
              style={{ display: 'inline-block', textAlign: 'left' }}
            >
              <div className="newsletter alt" id="newsletter-form-wrapper-4">
                <h3>
                  <b>Chci vědět</b>, kdo pro zákony hlasoval
                </h3>
                <form
                  role="form"
                  className="std form-newsletter"
                  id="newsletter"
                  method="post"
                  encType="application/x-www-form-urlencoded"
                  action="https://rekonstrukcestatu.us4.list-manage.com/subscribe/post?u=5d66fd73a6a5bb1624ddc06a0&id=c62bdfab00"
                  noValidate
                  data-error-element="label"
                  data-error-class="error"
                  onSubmit={evt => {
                    if (this.props.gaSubscribeId && typeof ga !== 'undefined') {
                      evt.preventDefault()
                      evt.persist()

                      ga(
                        'send',
                        'event',
                        'subscribe',
                        'newsletter',
                        this.props.gaSubscribeId,
                        {
                          hitCallback() {
                            evt.target.submit()
                          },
                        },
                      )
                    }
                  }}
                >
                  <div className="cell-set">
                    <div className="cell">
                      <div className="ib">
                        <div className="input-1">
                          <input
                            type="text"
                            name="MMERGE3"
                            id="MMERGE3"
                            required="required"
                            className="text"
                            placeholder="Vaše PSČ"
                          />
                        </div>
                        <div className="input-2">
                          <input
                            type="text"
                            name="EMAIL"
                            id="EMAIL"
                            className="text"
                            placeholder="Váš e-mail"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <p>
                    Přidejte se k dalším <b>42 898</b> voličů, kteří dostanou
                    informace, kdo z politiků dodrží sliby.
                  </p>
                  <div className="more-divider">
                    <div className="btn-wrapper">
                      <button
                        type="submit"
                        id="send"
                        name="send"
                        className="btn"
                        value="send"
                      >
                        Hlídám sliby!
                      </button>
                    </div>{' '}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div
            className="row"
            style={{ maxWidth: '100%', textAlign: 'center' }}
          >
            <div
              className="grid_7 suffix_1 omega"
              style={{ display: 'inline-block', textAlign: 'left' }}
            >
              <h3>Mapa stránek</h3>
              <ul className="sitemap clearfix">
                <li>
                  <a href="/cs">Rekonstrukce státu</a>
                </li>
                <li>
                  <a href="/cs/seznam-politiku">Politici</a>
                </li>
                <li>
                  <a href="/cs/zapoj-se">Zapoj se</a>
                </li>
                <li>
                  <a href="/cs/o-projektu">O nás</a>
                </li>
                <li>
                  <a href="/cs/pro-media">Pro média</a>
                </li>
                <li>
                  <a href="/cs/archiv-novinek">Aktuality</a>
                </li>
              </ul>
              <ul>
                <li>
                  <a href="/en">English</a>
                </li>
              </ul>

              <h3>Kontaktujte nás</h3>
              <ul>
                <li>
                  <a href="mailto:info@rekonstrukcestatu.cz">
                    info@rekonstrukcestatu.cz
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="grid_7 suffix_1 omega"
              style={{ display: 'inline-block', textAlign: 'left' }}
            >
              <h3>Zákony</h3>
              <ul className="clearfix">
                <li>
                  <a href="/cs/pruhledne-financovani-politickych-stran-a-volebnich-kampani">
                    01 - Politika bez tajných sponzorů
                  </a>
                </li>
                <li>
                  <a href="/cs/elektronicka-majetkova-priznani-ke-dni-nastupu-do-funkce">
                    02 - Majetková přiznání politiků
                  </a>
                </li>
                <li>
                  <a href="/cs/smlouvy-na-internetu">
                    03 - Smlouvy na internetu
                  </a>
                </li>
                <li>
                  <a href="/cs/zruseni-anonymnich-akcii">
                    04 - Zrušení anonymních akcií
                  </a>
                </li>
                <li>
                  <a href="/cs/odborne-nominace-do-dozorcich-rad">
                    05 - Konec trafik ve státních firmách
                  </a>
                </li>
                <li>
                  <a href="/cs/odpolitizovani-statni-spravy">
                    06 - Odpolitizování státní správy
                  </a>
                </li>
                <li>
                  <a href="/cs/statni-zastupitelstvi-bez-politickych-zasahu-do-vysetrovani">
                    07 - Nezávislé vyšetřování korupce
                  </a>
                </li>
                <li>
                  <a href="/cs/pruhledny-legislativni-proces">
                    08 - Zákony bez přílepků
                  </a>
                </li>
                <li>
                  <a href="/cs/rozsireni-kontrolnich-pravomoci-nku">
                    09 - Rozšíření pravomocí NKÚ
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="grid_8 alpha"
              style={{ display: 'inline-block', textAlign: 'left' }}
            >
              <iframe
                src="//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2FRekonstrukceStatu&amp;width=310&amp;height=290&amp;colorscheme=light&amp;show_faces=true&amp;header=true&amp;stream=false&amp;show_border=false&amp;appId=263765047137953"
                scrolling="no"
                frameBorder="0"
                style={{
                  border: 'none',
                  overflow: 'hidden',
                  width: 310,
                  height: 290,
                }}
                allowTransparency="true"
              />
            </div>
          </div>
        </div>
        <div className="footer-bar">
          <div
            style={{ position: 'relative', maxWidth: 950, margin: '0 auto' }}
          >
            <div className="grid_24">
              <p className="copy">
                &copy; Rekonstrukce státu 2017 - Všechna práva vyhrazena.
              </p>
            </div>
            <p
              style={{
                lineHeight: '58px',
                float: 'right',
                margin: 0,
                position: 'absolute',
                right: 15,
                top: 0,
              }}
            >
              <a
                href="https://blog.skorepa.info"
                style={{ color: '#959595', textDecoration: 'none' }}
              >
                Jakub Skořepa
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}
export default Footer



// WEBPACK FOOTER //
// ./components/layout/Footer.js